import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { userManager } from '../../index';
import sharedApi from '../../api/shared';
import withLocale from 'jsx/locale/withLocale';
import { setLanguage } from 'jsx/locale/ducks';

class UserMenu extends React.Component {
  state = {
    cls: 'settings-drop menu-dropdown dropdown--dark transition',
    clsOpen: 'open',
    products: []
  };

  componentDidMount = async () => {
    const data = await sharedApi.getSettingsUrls();

    if (Object.keys(data).length === 0) {
      console.debug("sorting");
      data.sort((a, b) => {
        if (a.levelOrder < b.levelOrder) {
          return -1;
        }
        if (a.levelOrder > b.levelOrder) {
          return 1;
        }
        return 0;
      });
    }

    if (!data.error) {
      this.setState({ products: data });
    }
  };

  toggleLang = () => {
    // TODO: Toggle language switch
    this.props.setLanguage(this.props.current === 'is' ? 'en' : 'is');
    this.props.toggleMenu();
  };

  render() {
    const { cls, clsOpen } = this.state;
    const { open, toggleMenu, t, current } = this.props;
    return (
      <div
        className={open ? `${cls} ${clsOpen}` : cls}
        style={{ width: '180px', color: '#2d2d2d' }}
      >
        <ul>
          {this.state.products.map(p => {
            const trans = `Navigator.DisplayText.${p.navigationID}`;
            return (
              <li onClick={toggleMenu} key={p.navigationID}>
                <a href={p.url}>
                  <i className={p.icon} />
                  <span className="half-spacing-left">{t(trans) || p.displayText}</span>
                </a>
              </li>
            );
          })}
          <li onClick={this.toggleLang}>
            <a>
              <i className="icon-earth" />
              <span className="half-spacing-left">{current === 'is' ? 'English' : 'Íslenska'}</span>
            </a>
          </li>

          <li onClick={() => userManager.logOut()}>
            <a>
              <i className="icon-exit" />
              <span className="half-spacing-left">{t('portfolioMonitoring_userMenu_logout')}</span>
            </a>
          </li>
        </ul>
      </div>
    );
  }
}

const mapState = ({ locale }) => ({ current: locale.lang });
const mapDispatch = dispatch => ({ setLanguage: bindActionCreators(setLanguage, dispatch) });

export default connect(mapState, mapDispatch)(withLocale(UserMenu));



// WEBPACK FOOTER //
// ./src/pages/UserMenu/index.js